<template>
  <button
    class="h-[32px] min-w-[32px] rounded-[10px] flex items-center justify-center focus:outline-none focus:ring-[2px] focus:ring-[#E5E5E5] focus:ring-offset-[1px] transition-colors duration-[150ms] cursor-pointer"
    :class="{
      'shadow-[0px_1px_2px_0px_#0000001A] px-[16px] py-[8px] text-[14px]': type === 'default',
      'px-[16px] py-[8px] text-[14px]': type === 'ghost',
      'p-0': type === 'icon',
      'border-[1px] border-[#E5E5E5]': outline,
      'opacity-40 cursor-not-allowed pointer-events-none': disabled,
      'bg-[#F95E16] text-[#FFFFFF] hover:bg-[#E05510]': variant === 'primary',
      'border-[1px] border-[#F95E16] text-[#F95E16] bg-white hover:bg-[#FFF0E9]': variant === 'outline-primary',
      'border-[1px] border-[#E5E5E5] text-[#828282] bg-white hover:bg-[#F5F5F5]': variant === 'outline-secondary',
      'hover:bg-[#F5F5F5] hover:border-[#D0D0D0]': variant === 'default',
      'text-[#F95E16]': textColor === 'primary',
      'text-[#0A0A0A]': textColor === 'default',
    }"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default',
    },
    textColor: {
      type: String,
      default: '',
    },
  },
}
</script>
